module.exports = __webpack_public_path__ + "479c995385806775084c7ca1cb466af7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-2.jpg
// module id = 1160
// module chunks = 0